import { Pipe, PipeTransform } from '@angular/core';
import { PatientGender, patientGenderLabel } from '../util/PatientData';

/** Muestra el género del paciente como texto («Masculino» / «Femenino»). */
@Pipe({ name: 'patientGender' })
export class PatientGenderPipe implements PipeTransform
{
  transform(gender: PatientGender | null | undefined): string
  {
    return patientGenderLabel(gender);
  }
}
